// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.name-lenght {
  overflow: hidden;
  max-width: 700px;
}

.banner {
  display: block;
  max-width: 700px;
  margin: 10px auto !important;
  object-fit: contain;
  object-position: top;
  padding-bottom: 50px;
}

.card-content {
  padding-top: 4px;
}

.full-card {
  display: block;
  margin: 0 auto;
  max-width: 700px;
}`, "",{"version":3,"sources":["webpack://./src/app/user-events/user-events.page.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;AACF;;AAIA;EACE,cAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;AADF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,cAAA;EACA,cAAA;EACA,gBAAA;AAJF","sourcesContent":[".name-lenght {\n  overflow: hidden;\n  max-width: 700px;\n\n  // max-width: 20ch;\n}\n\n.banner {\n  display: block;\n  max-width: 700px;\n  margin: 10px auto !important;\n  object-fit: contain;\n  object-position: top;\n  padding-bottom: 50px;\n\n  // width: 100vw;\n  // max-height: 100px;\n}\n\n.card-content {\n  padding-top: 4px;\n}\n\n.full-card {\n  display: block;\n  margin: 0 auto;\n  max-width: 700px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
